import { z } from "zod/v4";

export const CrudScriptTagsResponseBodySchema = z.object({
  scriptTagEnabled: z.boolean(),
  scriptTagSrc: z.string().nullish(),
});

export type CrudScriptTagsRequestBodyType = z.infer<
  typeof CrudScriptTagsResponseBodySchema
>;
